module.exports = __webpack_public_path__ + "img/magnifying-glass-solid (1).svg";